module.exports = __webpack_public_path__ + "static/img/bg.b2557c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhuzhou/bg.png
// module id = XECD
// module chunks = 1